<div
  [formGroup]="formGroup()"
  class="question-container"
  [attr.id]="'question-' + question().id"
>
  @switch (question().type) {
    @case (QuestionType.Textarea) {
      <lib-question-textarea
        [labelPrefix]="labelPrefix()"
        [question]="question()"
        [questionForm]="formGroup()"
        [repeaterGroupId]="repeaterGroupId()"
        [showChanges]="showChanges()"
      ></lib-question-textarea>
    }
    @case (QuestionType.Input) {
      <lib-question-input
        [labelPrefix]="labelPrefix()"
        [questionForm]="formGroup()"
        [question]="question()"
        [questionsInRow]="questionsInRow()"
        [repeaterGroupId]="repeaterGroupId()"
        [showChanges]="showChanges()"
      ></lib-question-input>
    }
    @case (QuestionType.Datepicker) {
      <lib-question-datepicker
        [labelPrefix]="labelPrefix()"
        [question]="question()"
        [questionForm]="formGroup()"
        [questionsInRow]="questionsInRow()"
        [repeaterGroupId]="repeaterGroupId()"
        [showChanges]="showChanges()"
      ></lib-question-datepicker>
    }
    @case (QuestionType.DatepickerChangeRequest) {
      <lib-question-dates-change-request
        [labelPrefix]="labelPrefix()"
        [question]="question()"
        [questionForm]="formGroup()"
        [repeaterGroupId]="repeaterGroupId()"
      ></lib-question-dates-change-request>
    }
    @case (QuestionType.Classification) {
      <lib-question-classification
        [labelPrefix]="labelPrefix()"
        [question]="question()"
        [questionForm]="formGroup()"
        [questionsInRow]="questionsInRow()"
        [repeaterGroupId]="repeaterGroupId()"
        [showChanges]="showChanges()"
      ></lib-question-classification>
    }
    @case (QuestionType.RadioButton) {
      <lib-question-radiobutton
        [labelPrefix]="labelPrefix()"
        [questionForm]="formGroup()"
        [question]="question()"
        [repeaterGroupId]="repeaterGroupId()"
        [showChanges]="showChanges()"
      ></lib-question-radiobutton>
    }
    @case (QuestionType.Dropdown) {
      <lib-question-dropdown
        [labelPrefix]="labelPrefix()"
        [questionForm]="formGroup()"
        [question]="question()"
        [repeaterGroupId]="repeaterGroupId()"
        [showChanges]="showChanges()"
      ></lib-question-dropdown>
    }
    @case (QuestionType.InputTable) {
      <lib-question-input-table
        [labelPrefix]="labelPrefix()"
        [questionForm]="formGroup()"
        [question]="question()"
        [repeaterGroupId]="repeaterGroupId()"
        [showChanges]="showChanges()"
      ></lib-question-input-table>
    }
    @case (QuestionType.Repeater) {
      <lib-question-repeater
        [questionForm]="formGroup()"
        [question]="question()"
        [showAllFollowUps]="showAllFollowUps()"
      ></lib-question-repeater>
    }
    @case (QuestionType.Checkbox) {
      <lib-question-checkbox
        [labelPrefix]="labelPrefix()"
        [questionForm]="formGroup()"
        [question]="question()"
        [repeaterGroupId]="repeaterGroupId()"
        [showChanges]="showChanges()"
      ></lib-question-checkbox>
    }
    @case (QuestionType.Information) {
      <lib-question-information
        [question]="question()"
        [repeaterGroupId]="repeaterGroupId()"
      ></lib-question-information>
    }
    @case (QuestionType.FileUpload) {
      <lib-question-file-upload
        [labelPrefix]="labelPrefix()"
        [question]="question()"
        [valueFormControl]="formGroup().get('value')"
        allowedFileTypes=""
        [repeaterGroupId]="repeaterGroupId()"
        [showChanges]="showChanges()"
      ></lib-question-file-upload>
    }
    @case (QuestionType.Worksite) {
      <lib-question-oreg
        [labelPrefix]="labelPrefix()"
        [questionForm]="formGroup()"
        [question]="question()"
        [repeaterGroupId]="repeaterGroupId()"
        [isChangeRequest]="isChangeRequest"
      ></lib-question-oreg>
    }
    @case (QuestionType.Person) {
      <lib-question-person
        [labelPrefix]="labelPrefix()"
        [questionForm]="formGroup()"
        [question]="question()"
        [repeaterGroupId]="repeaterGroupId()"
        [showChanges]="showChanges()"
      ></lib-question-person>
    }
    @case (QuestionType.Budget) {
      <lib-question-budget
        [questionForm]="formGroup()"
        [question]="question()"
        [repeaterGroupId]="repeaterGroupId()"
        [formBuilder]="formBuilder()"
      ></lib-question-budget>
    }
    @case (QuestionType.GlobalGoals) {
      <lib-question-global-goals
        [questionForm]="formGroup()"
        [question]="question()"
        [repeaterGroupId]="repeaterGroupId()"
      ></lib-question-global-goals>
    }
    @case (QuestionType.SarskildaVillkor) {
      <lib-question-sarskilda-villkor
        [questionForm]="formGroup()"
        [question]="question()"
      ></lib-question-sarskilda-villkor>
    }
    @case (QuestionType.Signering) {
      <lib-question-signering
        [labelPrefix]="labelPrefix()"
        [question]="question()"
        [valueFormControl]="formGroup().get('value')"
        allowedFileTypes=""
        [repeaterGroupId]="repeaterGroupId()"
      ></lib-question-signering>
    }
  }
</div>
